import React, { useEffect, useState } from "react";
import VideoTrackerPercentage from "../../../utils/common-functions/VideoTrackerPercentage";
import { useSelector } from "react-redux";
import {LessonsService} from "../../../services/lessonsService/lessonsService";

const RecordedVideoSession = ({ video, id = null, onEnded, autoplay = false, onGetDuration = null }) => {
    const userType = useSelector((state) => state?.auth?.userData?.user_type);
    const { videoRef, integerDuration, percentageWatched } = VideoTrackerPercentage();
    const [attendanceUpdated, setAttendanceUpdated] = useState(false);

    const updateAttendance = () => {
        if (userType !== 4 && id) {
            LessonsService.updatedLessonProgress(id, integerDuration, videoRef.current.currentTime)
                .catch((error) => {
                    console.error("API error:", error);
                });
        }
    };

    const handlePause = () => {
        updateAttendance();
        setAttendanceUpdated(true);
    };

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.addEventListener("pause", handlePause);
            if (onEnded) {
                videoRef.current.addEventListener("ended", onEnded);
            }
        }

        return () => {
            if (videoRef.current) {
                videoRef.current.removeEventListener("pause", handlePause);
                if (onEnded) {
                    videoRef.current.removeEventListener("ended", onEnded);
                }
            }
        };
    }, [videoRef, percentageWatched, id, attendanceUpdated]);

    useEffect(() => {
        if (videoRef.current && autoplay) {
            videoRef.current.muted = true;
            videoRef.current.play().then(() => {
                videoRef.current.muted = false;
            }).catch((error) => {
                console.error("Video autoplay error:", error);
            });
        }
    }, []);

    useEffect(() => {
        if (onGetDuration) {
            onGetDuration(integerDuration);
        }
    }, [integerDuration]);

    return (
        <div>
            <video ref={videoRef} controls className="dashboard-video" crossOrigin="anonymous">
                <source src={video} type="video/mp4" />
            </video>
        </div>
    );
};

export default RecordedVideoSession;
